<template>
<div class="creador">
	<div class="icono">
		<img src="img/H-logo.svg" height="100%" width="100%">
	</div>
	<div class="descripcion">
		<div class="texto p-2">
			<span style="color: #DEDEDE;">Creado por:</span> 
			<br> 
			<span>Edward Trigos Lopez</span>
		</div>
		<div class="redes">
			<span>
				<a href="https://gitlab.com/edtlsoft" target="_blank" class="i-gt">
					<i class="fab fa-gitlab"></i>
				</a>
			</span>

			<span>
				<a href="https://github.com/edtlsoft" target="_blank" class="i-gh">
					<i class="fab fa-github"></i>
				</a>
			</span>
		</div>
	</div>
</div>
</template>
<script>
export default {
	name: 'HCreditos'
}
</script>